import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DeviceTable from "components/device/all/ServiceSideTable";

export let setAttr = () => {};
export let attr = {};

const AllDevices = ({ sidebarTheme, layoutTheme }) => {

    [attr, setAttr] = useState({"time": new Date(), "value": "level1"});
    const [devices, setDevices] = useState([]);
    

    useEffect(() => {
        fetch(`/service/devices/deviceswithoneattr?time=${encodeURIComponent(attr.time)}&value=${encodeURIComponent(attr.value)}`)
        .then(res => res.json())
        .then(_devices =>setDevices(_devices))
    },[attr]);

    return (
        <div>
            <DeviceTable devices={devices}/>
        </div>
  );
};
const mapStateToProps = state => {
    return {
        ...state.themeChanger
    };
};

export default connect(
    mapStateToProps,
    null
)(AllDevices);
